// peekaboo header
(function () {
  if (window.__tugsScrollBound) return;
  window.__tugsScrollBound = true;

  function onReady(fn){
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  onReady(function () {
    var body = document.body;
    var lastScroll = 0;

    window.addEventListener('scroll', function () {
      var currentScroll = window.scrollY || window.pageYOffset || 0;

      if (currentScroll <= 0) {
        body.classList.remove('scroll-up', 'scroll-down');
        lastScroll = 0;
        return;
      }

      if (currentScroll > lastScroll && !body.classList.contains('scroll-down')) {
        body.classList.remove('scroll-up');
        body.classList.add('scroll-down');
      } else if (currentScroll < lastScroll && body.classList.contains('scroll-down')) {
        body.classList.remove('scroll-down');
        body.classList.add('scroll-up');
      }

      lastScroll = currentScroll;
    }, { passive: true });
  });
})();


// fade dropmenu
// Looks for the FIRST element with this class name
document.addEventListener('DOMContentLoaded', () => {
    // 1. Select ALL buttons with this class
    const triggers = document.querySelectorAll('.fadeTargetButton');
    const box = document.querySelector('.fadebox');

    if (triggers.length > 0 && box) {
        // 2. Loop through every trigger and attach the click event
        triggers.forEach(trigger => {
            trigger.onclick = function(event) {
                event.stopPropagation(); // Stops click from reaching document
                box.classList.toggle('show');
            };
        });

        // 3. Prevent closing when clicking INSIDE the box itself
        box.onclick = function(event) {
            event.stopPropagation();
        };

        // 4. Click anywhere else on the screen to close
        document.onclick = function() {
            box.classList.remove('show');
        };
    }
});
